// null means the supplied prices already include VAT; zero is a tax rate.
export const isVatIncluded = (contract) => contract?.vat === null;

export const getPaymentVat = (profile) =>
  profile?.vat ?? 10;

export const amountAfterVat = (amount, vat) =>
  Math.round(Number(amount || 0) * (1 + Number(vat ?? 0) / 100));

